'use client'
import { MediaDataTypes } from '@/components/atoms/media/MediaData'
import { CustomGrid } from '@/components/layout/grid/CustomGrid'
import { renderMedia } from '@/utils/renderMediaComponent'
import { chakra, GridItem } from '@chakra-ui/react'

export interface MediaComponentProps {
  isFullWidth?: boolean
  mediaData?: MediaDataTypes
}

/**
 * Represents a Media component.
 * @param mediaElement - ReactNode to render. This will be a image, video, or embed. @see {@link MediaComponentFactory} for a render example
 * @param isFullWidth - Indicates whether this media item should be rendered full width or not.
 * @returns Media Component
 */
export default chakra(MediaComponent)
export function MediaComponent({
  isFullWidth,
  mediaData,
  ...props
}: MediaComponentProps) {
  return (
    <CustomGrid px={isFullWidth ? 0 : undefined} overflow='hidden'>
      <GridItem
        colStart={{ base: 1, lg: isFullWidth ? 1 : 4 }}
        colSpan={{ base: 12, lg: isFullWidth ? 12 : 6 }}
        pr={isFullWidth ? { base: '1rem', md: 9, lg: 10 } : 0}
        {...props}
      >
        {mediaData &&
          renderMedia(
            {
              ...mediaData,
              isFullWidth: isFullWidth,
            },
            { base: 'wideScreen' },
            { base: 0.5, md: 0.6, lg: 1 },
          )}
      </GridItem>
    </CustomGrid>
  )
}
